export default "__VITE_ASSET__53e4d715__"